import {
  DicomNodeConfigRequestBody,
  DicomNodeConfigResponse,
} from '@models/DicomNode';
import { DicomNodeParams, DicomNodeParamsWithoutId } from '@models/pacs';
import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

const getDicomNodeApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/dicomNode`;
};

export const getDicomNode = async ({
  accessToken,
}: {
  accessToken: string;
}) => {
  const DicomNode_URL = await getDicomNodeApi();
  const response: AxiosResponse<DicomNodeParams[]> = await axios
    .get(`${DicomNode_URL}`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const postDicomNode = async ({
  accessToken,
  params,
}: {
  accessToken: string;
  params: DicomNodeParamsWithoutId;
}) => {
  const DicomNode_URL = await getDicomNodeApi();
  const response: AxiosResponse = await axios
    .post(DicomNode_URL, params, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  return response;
};

export const patchDicomNode = async ({
  accessToken,
  params,
  id,
}: {
  accessToken: string;
  params: DicomNodeParamsWithoutId;
  id: string;
}) => {
  const DicomNode_URL = await getDicomNodeApi();
  const response: AxiosResponse = await axios
    .patch(`${DicomNode_URL}/${id}`, params, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const deleteDicomNode = async ({
  accessToken,
  id,
}: {
  accessToken: string;
  id: string;
}) => {
  const DicomNode_URL = await getDicomNodeApi();
  const response: AxiosResponse = await axios
    .delete(`${DicomNode_URL}/${id}`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const getDicomNodeConfig = async ({
  accessToken,
}: {
  accessToken: string;
}) => {
  const DicomNode_URL = await getDicomNodeApi();
  const response: AxiosResponse<DicomNodeConfigResponse> = await axios
    .get(`${DicomNode_URL}/config`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const patchDicomNodeConfig = async ({
  accessToken,
  params,
}: {
  accessToken: string;
  params: DicomNodeConfigRequestBody;
}) => {
  const DicomNode_URL = await getDicomNodeApi();
  const response: AxiosResponse = await axios
    .patch(`${DicomNode_URL}/config`, params, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};
